import ReactOnRails from 'react-on-rails/client';
import RegistrationsList from '../../app/RegistrationsList.jsx';

ReactOnRails.register({RegistrationsList});